module.exports = __webpack_public_path__ + "finance.bIclbGSb.svg";